"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDeleteStream = void 0;
var resolvers_1 = require("../resolvers");
var StreamNetwork_1 = require("../utils/StreamNetwork");
var IncorrectNetworkError_1 = require("../utils/IncorrectNetworkError");
var makeDeleteStream = function (endpoints) {
    var evmFetcher = endpoints.createFetcher(resolvers_1.deleteStreamEvm);
    return function (_a) {
        var networkType = _a.networkType, options = __rest(_a, ["networkType"]);
        switch (networkType) {
            case StreamNetwork_1.StreamNetwork.EVM:
                return evmFetcher(__assign({}, options));
            default:
                if (networkType === undefined) {
                    return evmFetcher(__assign({}, options));
                }
                throw new IncorrectNetworkError_1.IncorrectNetworkError(networkType);
        }
    };
};
exports.makeDeleteStream = makeDeleteStream;
